import React from 'react';
import { twMerge } from 'tailwind-merge';
interface LogoProps {
  className?: string;
  showWord?: boolean;
}
export function Logo({
  className,
  showWord = true
}: LogoProps) {
  return <span className={twMerge('inline-flex items-center gap-2 text-xl font-bold tracking-[-0.02em] text-ink', className)} data-id="element-794" data-mp="rvl4ecrkmczp">
      <span className="grid h-9 w-9 place-items-center rounded-sm bg-brand text-on-brand" data-id="element-795" data-mp="ntgenp48u0ic">
        <svg viewBox="0 0 20 20" className="h-5 w-5" aria-hidden="true" data-id="element-796" data-mp="ivokeog4m2az">
          <rect x="3" y="8" width="3" height="9" rx="1.5" fill="currentColor" data-id="element-797" data-mp="dwlgj7bvu24l" />
          <rect x="8.5" y="3" width="3" height="14" rx="1.5" fill="currentColor" data-id="element-798" data-mp="dyogaj2u79mi" />
          <rect x="14" y="6" width="3" height="11" rx="1.5" fill="currentColor" data-id="element-799" data-mp="8xil8elpfa9t" />
        </svg>
      </span>
      {showWord && <span data-id="element-800" data-mp="4xzxzc6eun3t">encorza</span>}
    </span>;
}